<template>

  <div class="section-group" :id="`uuid-${model.uuid}`">
    <menu-icon-text :categoryList="model.categoryList" v-if="model.categoryList && Object.keys(model.categoryList).length > 0"/>
    <template v-for="(articles, index) in model.articleList" >
      <!-- Article Featured -->
      <!-- Articles With Featured -->
      <pg-listing v-bind="articles" :key="index" :usePagination="model.usePagination" :discoverMore="model.discoverMore"/>
    </template>
  </div>

</template>
<script>
  import {mgnlComponentMixin} from "@wl-vue-mixins/mixins.js";
  import PgListing            from "../Listing/Listing";
  import MenuIconText from "../MenuIconText/MenuIconText";

  export default {
    mixins: [mgnlComponentMixin], // !!! all the mgnl components must be configured with mgnlComponentMixin !!!

    name: "MgnlListingArticlesWithFeatured",

    components: {
      PgListing,
      MenuIconText
    }
  };
</script>
